import { format } from 'date-fns';

const DATE_FORMAT = "yyyy-MM-dd, HH:mm:ss";

const DATE_FORMAT2 = "HH:mm:ss";


export class DateUtils {


    static isSameDay(date1: Date, date2: Date): boolean {
        // date2'yi Date nesnesine dönüştürüyoruz
        const d2 = new Date(date2);

        // Date nesnesi olup olmadıklarını kontrol edelim
        if (!(date1 instanceof Date) || isNaN(date1.getTime()) || isNaN(d2.getTime())) {
            console.error('Tarihlerden biri geçerli bir Date nesnesi değil');
            return false;
        }

        // Tüm tarih bileşenlerini karşılaştırıyoruz
        return (
            date1.getFullYear() === d2.getUTCFullYear() &&
            date1.getMonth() === d2.getUTCMonth() &&
            date1.getDate() === d2.getUTCDate()
        );
    }
    static dateFormat(now: Date, date: Date): string {
        let ff = DATE_FORMAT;
        if (this.isSameDay(now, date)) {
            ff = DATE_FORMAT2;
        }
        return format(date, ff);
    }

    static formatDuration(seconds:number) {
        const days = Math.floor(seconds / (24 * 3600)); // Gün sayısını hesapla
        seconds %= (24 * 3600); // Kalan saniyeleri hesapla
        const hours = Math.floor(seconds / 3600); // Saat sayısını hesapla
        seconds %= 3600; // Kalan saniyeleri hesapla
        const minutes = Math.floor(seconds / 60); // Dakika sayısını hesapla
        seconds %= 60; // Kalan saniyeleri hesapla
      
        // Formatı oluştur
        let result="";
        if (days > 0) result= `${days}d, `;
        
        return `${result}${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
      

}

